import { Injectable, inject } from '@angular/core';

import { ModalService } from '~/app/shared/services/modal/modal.service';

import { ModalProfessionalInfoComponent } from '../modals/modal-professional-info/modal-professional-info.component';

@Injectable({
    providedIn: 'root',
})
export class ModalProfessionalInfoService {
    private modal = inject(ModalService);

    public open() {
        return this.modal.open(
            ModalProfessionalInfoComponent,
            undefined,
            {
                // La popin porte sa propre marge intérieure (maquette « Popin Onboarding ») : son pied va jusqu'aux bords,
                // ce que les 2rem du cadre commun empêcheraient.
                padding: false,
                hasBorder: true,
                // EF-3852 (décision PO) : fermable par la croix et le clic en dehors, la saisie n'est pas obligatoire.
                isOutsideClickCloseModal: true,
                closable: true,
                overflow: true,
            },
        );
    }
}
